import { MasterdataService } from './masterdata.provider';
import { MasterdataRestService } from './services/masterdata.service';

export const masterdataState = {
  parent: "app",
  name: "masterdata",
  url: "/masterdata",
  redirectTo: "masterdata.list",
  component: "masterdataComponent"
};

export const masterdataListState = {

  name: "masterdata.list",
  url: "/list?:tab",
  params: {
    tab: { dynamic: true },
  },
   resolve: {
        item: (MasterdataRestService: MasterdataRestService, MasterdataService: aboMasterdata.IService) => {
            'ngInject';
            console.log(MasterdataService.getApiItemName())
            return MasterdataRestService.setItemName(MasterdataService.getApiItemName());
        }
    },
  views: {
    "main": 'masterdataListComponent'
  }

};

export const masterdataListEditState = {

    name: "masterdata.list.edit",
    url: "/edit/:id?:type",
    params: {
        id: null,
        type: null
    },
    modal: true,
    resolve: {
        item: (MasterdataRestService: MasterdataRestService, MasterdataService: aboMasterdata.IService, $stateParams: ng.ui.IStateParamsService) => {
            'ngInject';
            if ($stateParams['id'] !== '') {
                MasterdataRestService.setItemName(MasterdataService.getApiItemName());
                return MasterdataRestService.get($stateParams['id']);
            }
        }
    },
    component: 'masterdataEditComponent'

};



// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/masterdata.states.ts